import { httpsOnly } from '@/lib/site/safe-url';

/** One network the site links to: its name, its logo (a static file in `public/social`) and where it leads. */
export interface SocialLink {
  key: string;
  name: string;
  logo: string;
  href: string;
}

/** The networks the site shows, in this order — no others, however many the settings hold (D-318). */
const NETWORKS = [
  { key: 'instagram', name: 'Instagram', logo: '/social/instagram.svg' },
  { key: 'facebook', name: 'Facebook', logo: '/social/facebook.svg' },
  { key: 'youtube', name: 'YouTube', logo: '/social/youtube.svg' },
] as const;

/** The links to show for `social.links` of the public settings: those networks that have an https address. */
export function socialLinks(social: Readonly<Record<string, string>>): SocialLink[] {
  const links: SocialLink[] = [];
  for (const { key, name, logo } of NETWORKS) {
    const href = httpsOnly(social[key]);
    if (href) links.push({ key, name, logo, href });
  }
  return links;
}
